import React, { useEffect, useState } from 'react';
import Spinner from './iconSvgs/spinner';

interface PreLoaderProps {
    children: React.ReactNode;
}

const PreLoader: React.FC<PreLoaderProps> = ({ children }) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return (
            <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
                <div className="flex flex-col items-center gap-8">
                    {/* Logo at the top */}
                    <img 
                        src="/assets/images/logo.png" 
                        alt="Wine Data Systems" 
                        className="w-64 animate-pulse text-black"
                    />
                    {/* <Spinner className="w-12 h-12 text-[#4A071C]" /> */}

                    {/* Alternative logo position at bottom - uncomment to use */}
                    {/* <div className="absolute bottom-10">
                        <img 
                            src="/assets/images/logo.png" 
                            alt="Wine Data Systems" 
                            className="w-48 opacity-50"
                        />
                    </div> */}
                </div>
            </div>
        );
    }

    return <>{children}</>;
};

export default PreLoader;